function addCartItem (item) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }
        return data;
      });
    })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
      if (!document.documentElement.classList.contains('js-drawer-open--cart')) {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    });
}

function updateCartItem (item) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  })
  .then(response => response.json())
  .then(() => {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  })
  .catch(console.error)
}

function removeItemFromCart(id) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: id,
      quantity: 0
    })
  })
  .then(response => response.json())
  .then(() => {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  })
  .catch(console.error)
}

function setCustomSubscriptionSelect () {
  var x, i, j, l, ll, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    if(x[i].querySelector('.select-selected')) break;
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 0; j < ll; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      if(selElmnt.options[j].selected) {
        c.classList.add("selected");
      }
      c.addEventListener("click", function(e) {
          /*when an item is clicked, update the original select box,
          and the selected item:*/
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              s.dispatchEvent(new Event('change'));
              break;
            }
          }
          h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
  }
  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
  document.addEventListener("click", closeAllSelect);
};

function addEventListenerOnce(element, event, listener) {
  if (!element.dataset[event + 'Listener']) {
      element.addEventListener(event, listener);
      element.dataset[event + 'Listener'] = true;
  }
}

document.addEventListener("cart:built", () => {
  setCustomSubscriptionSelect();
});


document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.grid__item-image-wrapper')
    .forEach(function (wrapper) {
      var imageLink = wrapper.querySelector('.image-wrap')
      if (imageLink) {
        imageLink.addEventListener('focus', function () {
          wrapper.classList.add('show-hover-image')
        })
        imageLink.addEventListener('blur', function () {
          wrapper.classList.remove('show-hover-image')
        })
      }
    })

  initTexasLocationDetection();
})

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days = 30) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

async function checkUserLocation() {
  try {
    const response = await fetch('https://cleanskinclub.fly.dev/api/geolocation', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data && typeof data.region === 'string') {
      const isFromTexas = data.region === 'TX' ? '2' : '1';
      setCookie('is_from_texas', isFromTexas);
      return isFromTexas;
    } else {
      setCookie('is_from_texas', '1');
      return '1';
    }
  } catch (error) {
    console.warn('Failed to detect location:', error);
    setCookie('is_from_texas', '1');
    return '1';
  }
}

function initTexasLocationDetection() {
  const existingCookie = getCookie('is_from_texas');
  
  if (!existingCookie) {
    setCookie('is_from_texas', '0');
    checkUserLocation();
  }
}

window.texasLocationDetection = {
  getCookie: getCookie,
  setCookie: setCookie,
  checkUserLocation: checkUserLocation,
  reset: function() {
    document.cookie = 'is_from_texas=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    initTexasLocationDetection();
  },
  getStatus: function() {
    const cookieValue = getCookie('is_from_texas');
    const statuses = {
      '0': 'Initial state - location not checked yet',
      '1': 'Location checked - user is NOT from Texas', 
      '2': 'Location checked - user IS from Texas',
      null: 'No cookie set'
    };
    return {
      value: cookieValue,
      description: statuses[cookieValue] || 'Unknown status'
    };
  }
};


function fixGorgiasChatAccessibility() {
  const gorgiasIframe = document.querySelector('iframe[id="chat-button"][class*="gorgias-chat"]');
  
  if (gorgiasIframe && !gorgiasIframe.dataset.ariaFixed) {
    // Remove invalid role
    gorgiasIframe.removeAttribute('role');

    // Set proper ARIA attributes
    gorgiasIframe.setAttribute('aria-label', 'Live chat support');
    gorgiasIframe.setAttribute('aria-live', 'polite');

    // Ensure descriptive title
    if (!gorgiasIframe.getAttribute('title') || gorgiasIframe.getAttribute('title') === 'Gorgias live chat messenger') {
      gorgiasIframe.setAttribute('title', 'Live chat support - Click to open chat window');
    }
    // Mark as fixed to avoid repeating
    gorgiasIframe.dataset.ariaFixed = "true";
  }
}

// Run immediately in case it's already there
document.addEventListener('DOMContentLoaded', fixGorgiasChatAccessibility);
document.addEventListener('page:loaded', fixGorgiasChatAccessibility);

// Use MutationObserver for dynamic load
const observer = new MutationObserver(() => {
  fixGorgiasChatAccessibility();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});